import { YouLeaveModalActionType } from '../../types/youLeaveModalType'

export const closeYouLeaveModal = () => {
    return {type: YouLeaveModalActionType.CLOSE_YOU_LEAVE_MODAL}
}

export const openYouLeaveModal = () => {
    return {type: YouLeaveModalActionType.OPEN_YOU_LEAVE_MODAL}
}